import request from './request'

export function getVideos(params) {
  return request({
    url: '/videos',
    method: 'get',
    params
  })
}

export function getVideo(id) {
  return request({
    url: `/videos/${id}`,
    method: 'get'
  })
}

export function getHomeVideos() {
  return request({
    url: '/home-videos',
    method: 'get'
  })
}

export function incrementViews(id) {
  return request({
    url: `/videos/${id}`,
    method: 'get'
  })
}
